import Header from "components/Common/Header/Header";
import RespirationRateBody from "components/PatientManagement/Vital/RespirationRate/RespirationRateBody";
import React, { useEffect } from "react";

const RespirationRate = () => {
  useEffect(() => {
    document.title = "Vitals | Respiration Rate";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <RespirationRateBody />
    </main>
  );
};

export default RespirationRate;
